"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTotpFromSharedSecret = void 0;
const otplib_1 = require("otplib");
const _1 = require(".");
/**
 * Computes a TOTP code from a shared secret and client secret.
 *
 * WARNING: due to the way the TOTP secret material is being derived from
 * the shared and client secrets, the overall mechanism is not as secure as
 * generating a "random" TOTP secret as would normally be done with a
 * client device. This is because TOTP can take a base32 encoded secret
 * where as this algorithm produces a base16 encoded secret
 */
function computeTotpFromSharedSecret(sharedSecret, clientSecret, epoch) {
    const previousEpoch = otplib_1.totp.options.epoch;
    //crappy API requires us to set options statically (i.e. globally)...
    otplib_1.totp.options = {
        ...otplib_1.totp.options,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        algorithm: 'sha512',
        digits: 9,
        window: 1,
        ...(epoch ? { epoch } : {}),
    };
    try {
        const xored = _1.xorStrings(sharedSecret, ..._1.chunkString(clientSecret, sharedSecret.length));
        return otplib_1.totp.generate(xored);
    }
    finally {
        if (typeof previousEpoch === 'number') {
            otplib_1.totp.options = {
                ...otplib_1.totp.options,
                epoch: previousEpoch,
            };
        }
    }
}
exports.computeTotpFromSharedSecret = computeTotpFromSharedSecret;
//# sourceMappingURL=totp.js.map